import { useCallback } from "react";
import { classNames } from "../../utils";
import {
  FolderPlusIcon as FolderAddIcon,
  ArrowPathIcon as RefreshIcon,
} from "@heroicons/react/24/outline";
import { useDropzone } from "react-dropzone";
import Button from "../../shared-components/Button";

type Props = {
  files: File[] | undefined;
  onChange: (files: File[] | undefined) => void;
  isHidden?: boolean;
};

const UploadDropZone = ({ files, onChange, isHidden }: Props) => {
  const onDrop = useCallback(
    async (acceptedFiles: File[]) => {
      if (!acceptedFiles) return;
      onChange(acceptedFiles);
    },
    [onChange]
  );

  const { getRootProps, getInputProps } = useDropzone({ onDrop });
  return (
    <>
      <div className="flex justify-between items-center">
        {!isHidden ? (
          <span className="text-sm font-semibold text-gray-500">
            CSV File Upload
          </span>
        ) : (
          <span></span>
        )}

        <div className="flex flex-col gap-y-2 justify-items-center">
          <Button
            text="Download Template"
            onClick={() => {
              window.open("/bulkload-template.csv");
            }}
            className="w-52"
          />
        </div>
      </div>
      {!isHidden && (
        <div>
          <div
            {...getRootProps()}
            className={classNames(
              "w-full rounded-lg border-2 p-4 my-4 border-dashed border-gray-300",
              files ? "hidden" : ""
            )}
          >
            <input {...getInputProps()} />

            <div className="flex flex-col justify-center items-center text-gray-300 p-6">
              <span>
                <FolderAddIcon className="w-32" />
              </span>
              <span>Add or Drop files to upload</span>
            </div>
          </div>
          {files && (
            <div className="w-full rounded-lg border-2 p-4 my-4 border-dashed border-gray-300 justify-center items-center flex text-gray-400">
              <RefreshIcon className="w-32 animate-spin" />
            </div>
          )}
          <div>
            <div className="text-gray-400 text-sm mt-4">
              Please use the correct CSV format (max size 5mb) by following our
              downloadable template. Simply drag and drop the file or click to
              browse. If you need help contact Customer Support.
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default UploadDropZone;
